import { ROUTES, isWorkspaceSourcesPath } from '@/shared/constants/routes';
import type { DatasetContentLayout } from '@/viewmodel/shared/sidebar/types';
import { useLocation, useSearchParams } from 'react-router-dom';

export function useDatasetContentViewModel(): DatasetContentLayout {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  if (pathname === ROUTES.DATA_STUDIO || searchParams.get('action') === 'create') return 'flush';
  if (
    pathname === ROUTES.DATASET ||
    pathname === ROUTES.DASHBOARDS ||
    isWorkspaceSourcesPath(pathname)
  ) {
    return 'scroll';
  }
  return 'padded';
}
